<template>
    <v-container>
      <v-row>
          <v-col cols="12">
            <div class="text-left" style="margin-bottom:20px;">
                <router-link to="/">
                    <v-btn
                        color="secondary"
                        class="text-right"
                        style="width:250px"
                    >
                        Back
                    </v-btn>
                </router-link>
              </div>                  
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h1>Las Vegas</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="text-left" style="margin-bottom:-100px;">
            February 26, 2026, Sydney to Las Vegas
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="text-left" style="margin-bottom:0px;">
            February 26, 2026, Def Leppard 
          </div>
        </v-col>
      </v-row>                    
      <v-row>
        <v-col cols="12">
          <div class="text-left" style="margin-bottom:0px;">
            February 28, 2026, NRL
          </div>
        </v-col>
      </v-row>                    
      <v-row>
        <v-col cols="12">
          <div class="text-left" style="margin-bottom:0px;">
            <a href="https://www.nrl.com/hospitality/nrl-las-vegas-hospitality/credit-one-club/" target="_blank">
              <v-btn
                color="primary"
                class="text-right"
                style="width:500px; margin-top:0px; margin-bottom:0px;"
              >
                NRL Las Vegas - Credit One Club
              </v-btn>
            </a>
          </div>
        </v-col>
      </v-row>      
      <v-row>
        <v-col cols="12">
          <div class="text-left" style="margin-bottom:20px;">
            <h2>2 Tickets to Caesars Suite for NRL</h2>
            <h2>YOUR EXCLUSIVE VIP SUITE EXPERIENCE</h2>
            <p>Never miss a second of the action in our Caesars Rewards Suite perfectly designed to elevate your experience:</p>
            <ul>
              <li><strong>Dedicated VIP Entrance:</strong> Bypass the crowds and step directly into the lap of luxury with your own exclusive entrance.</li>
              <li><strong>Complimentary Food and Drinks:</strong> Savor a selection of food and beverage, all included for your indulgence.</li>
              <li><strong>Premium Views:</strong> Relish in the best seats in the house with breathtaking views of every thrilling moment.</li>
              <li><strong>Private Bathroom:</strong> Enjoy the convenience of a private bathroom, ensuring you never miss a touchdown.</li>
            </ul>
          </div>
        </v-col>
      </v-row>      
      <div class="text-left">Las Vegas to London via San Francisco March 4th, 2026</div>
      <div class="text-left">The View Hotel, Eastborne March 5-10, 2026</div>
      <div class="text-left">London to Las Vegas via San Francisco March 11th, 2026</div>
      <div class="text-left" style="margin-top:20px; margin-bottom:20px;">Pennzoil 400 NASCAR Cup Series March 15, 2026</div>
      <div class="text-left">Las Vegas to Sydney March 18, 2026</div>
      <div class="text-left">Arrive Sydney March 20, 2026</div>

    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
    }
  }
  </script>